// import React from 'react';
// import { motion } from 'framer-motion';

// const data = [
//   { label: 'Start ups', icon: 'https://devarajuassociates.com/images/we-serv-1.png' },
//   { label: 'Banks', icon: 'https://devarajuassociates.com/images/we-serv-3.png' },
//   { label: 'Foreign subsidiaries', icon: 'https://devarajuassociates.com/images/we-serv-4.png' },
//   { label: 'Manpower', icon: 'https://devarajuassociates.com/images/we-serv-9.png' },
//   { label: 'Pharma & Healthcare', icon: 'https://devarajuassociates.com/images/we-serv-10.png' },
//   { label: 'Infrastructure & Realty', icon: 'https://devarajuassociates.com/images/we-serv-11.png' },
//   { label: 'Logistics', icon: 'https://devarajuassociates.com/images/we-serv-12.png' },
//   { label: 'Automobiles', icon: 'https://devarajuassociates.com/images/we-serv-13.png' },
//   { label: 'SAAS', icon: 'https://devarajuassociates.com/images/we-serv-14.png' },
//   { label: 'VFX', icon: 'https://devarajuassociates.com/images/we-serv-15.png' },
// ];

// const WhoWeServe = () => {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: -100 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8, ease: 'easeOut' }}
//       viewport={{ once: true, amount: 0.2 }}
//       style={{ padding: '60px 20px', backgroundColor: '#F9FAFB', textAlign: 'center' }}
//     >
//       <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '10px' }}>
//         <span style={{ color: '#5DA840' }}>Who </span>
//         <span style={{ color: '#5DA840' }}>We Serve</span>
//       </h2>

//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
//         <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//         <div
//           style={{
//             width: '10px',
//             height: '10px',
//             borderRadius: '50%',
//             backgroundColor: 'white',
//             border: '2px solid #023E62',
//             margin: '0 10px',
//           }}
//         />
//         <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//       </div>

//       {/* First Row */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '60px',
//         marginBottom: '30px',
//         flexWrap: 'nowrap'
//       }}>
//         {data.slice(0, 5).map((item, index) => (
//           <div key={index} style={{ width: '120px', textAlign: 'center' }}>
//             <img src={item.icon} alt={item.label} style={{ height: '60px', marginBottom: '10px' }} />
//             <p style={{ fontSize: '14px', color: '#111', fontWeight: 500 }}>{item.label}</p>
//           </div>
//         ))}
//       </div>

//       {/* Second Row */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '60px',
//         flexWrap: 'nowrap'
//       }}>
//         {data.slice(5).map((item, index) => (
//           <div key={index} style={{ width: '120px', textAlign: 'center' }}>
//             <img src={item.icon} alt={item.label} style={{ height: '60px', marginBottom: '10px' }} />
//             <p style={{ fontSize: '14px', color: '#111', fontWeight: 500 }}>{item.label}</p>
//           </div>
//         ))}
//       </div>
//     </motion.div>
//   );
// };

// export default WhoWeServe;









import React from 'react';
import { motion } from 'framer-motion';
import Startup from "../Assests/Startup.png";
import Banks from "../Assests/Banks.png";
import Foreign from "../Assests/Foreign.png";
import Infra from "../Assests/Infra.png";
import Logistics from "../Assests/Logistics.png";
import Manpower from "../Assests/Manpower.png";
import Pharma from "../Assests/Pharma.png";
import auto from "../Assests/auto.png";
import saas from "../Assests/saas.png";
import vfx from "../Assests/vfx.png";


const data = [
  { label: 'Start ups', icon: Startup},
  { label: 'Banks', icon: Banks  },
  { label: 'Foreign subsidiaries', icon: Foreign },
  { label: 'Manpower', icon:Manpower },
  { label: 'Pharma & Healthcare', icon: Pharma },
  { label: 'Infrastructure & Realty', icon: Infra },
  { label: 'Logistics', icon: Logistics },
  { label: 'Automobiles', icon: auto },
  { label: 'SAAS', icon: saas },
  { label: 'VFX', icon: vfx },
];

const WhoWeServe = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
      style={{ padding: '60px 20px', backgroundColor: '#F9FAFB', textAlign: 'center' }}
    >
      <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '10px' }}>
        <span style={{ color: '#5DA840' }}>Who </span>
        <span style={{ color: '#5DA840' }}>We Serve</span>
      </h2>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
        <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: 'white',
            border: '2px solid #023E62',
            margin: '0 10px',
          }}
        />
        <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
      </div>

      {/* First Row */}
      <div className="serve-row">
        {data.slice(0, 5).map((item, index) => (
          <div key={index} className="serve-item">
            <img src={item.icon} alt={item.label} className="serve-icon" />
            <p className="serve-text">{item.label}</p>
          </div>
        ))}
      </div>

      {/* Second Row */}
      <div className="serve-row">
        {data.slice(5).map((item, index) => (
          <div key={index} className="serve-item">
            <img src={item.icon} alt={item.label} className="serve-icon" />
            <p className="serve-text">{item.label}</p>
          </div>
        ))}
      </div>

      {/* Responsive CSS */}
      <style>
        {`
          .serve-row {
            display: flex;
            justify-content: center;
            gap: 60px;
            margin-bottom: 30px;
            flex-wrap: nowrap; /* ✅ desktop unchanged */
          }
          .serve-item {
            width: 120px;
            text-align: center;
          }
          .serve-icon {
            height: 60px;
            margin-bottom: 10px;
          }
          .serve-text {
            font-size: 14px;
            color: #111;
            font-weight: 500;
          }

          /* ✅ Mobile view = 2 items per row */
          @media (max-width: 768px) {
            .serve-row {
              flex-wrap: wrap !important;
              justify-content: center !important;
              gap: 20px !important;
            }
            .serve-item {
              width: 45% !important; /* 2 items per row */
            }
            .serve-icon {
              height: 50px !important;
            }
          }
        `}
      </style>
    </motion.div>
  );
};

export default WhoWeServe;
